export default __webpack_public_path__ + "static/media/acceptIcon.cb1e2f87.svg";